import {combineReducers} from "redux";

export function error(state = null, action) {
  switch (action.type) {
    case 'REVIEW_SCALES_UPDATE_ERROR':
      return action.error;
    case 'REVIEW_SCALES_UPDATE_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'REVIEW_SCALES_UPDATE_LOADING':
      return action.loading;
    case 'REVIEW_SCALES_UPDATE_RESET':
      return false;

    default:
      return state;
  }
}

export function success(state = false, action) {
  switch (action.type) {
    case 'REVIEW_SCALES_UPDATE_SUCCESS':
      return action.success;
    case 'REVIEW_SCALES_UPDATE_RESET':
      return null;

    default:
      return state;
  }
}

export function updated(state = null, action) {
  switch (action.type) {
    case 'REVIEW_SCALES_UPDATE_UPDATED':
      return action.updated;
    case 'REVIEW_SCALES_UPDATE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, updated, success });
